import React, {Component} from "react";

export default class SitePrepSvg extends Component{
    render() {
        const {color, width, height} = this.props;
        return (
            <svg width={width} height={height} viewBox="0 0 50 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="7" cy="32" r="3" fill={color}/>
                <circle cx="7" cy="23" r="3" fill={color}/>
                <circle cx="7" cy="41" r="3" fill={color}/>
                <circle cx="43" cy="32" r="3" fill={color}/>
                <circle cx="43" cy="23" r="3" fill={color}/>
                <circle cx="43" cy="41" r="3" fill={color}/>
                <circle cx="16" cy="41" r="3" fill={color}/>
                <circle cx="25" cy="41" r="3" fill={color}/>
                <circle cx="34" cy="41" r="3" fill={color}/>
                <path d="M3 15.5L25 4L46.5 15" stroke={color} strokeWidth="6" strokeLinecap="round"/>
            </svg>
        )
    }
}